import { TooltipProps } from '@material-ui/core/Tooltip';

const MuiTooltip: TooltipProps = {
    arrow: true,
    placement: 'top-end',
    title: null,
    children: null,
};

export default MuiTooltip;
